// extracted by mini-css-extract-plugin
export var collapsedSummary = "_r0-0";